import React, { useState } from 'react';
import { KiteCheckbox, KiteModal } from '@kite/react-kite';
import { DatePicker } from '@kite/react-kite-plus';
import dayjs from 'dayjs';

import './SwimlaneReadyModal.scss';
import { ISwimlane } from '../../utils/models';
import { getUnixTime } from '../../utils/helpers';

export interface ISwimlaneReadyModalProps {
  isOpen: boolean;
  swimlaneData: ISwimlane;
  onReady: (end?) => void;
  onHide: () => any;
}

const SwimlaneReadyModal = ({
  isOpen,
  swimlaneData,
  onReady,
  onHide,
}: ISwimlaneReadyModalProps) => {
  const getDateString = (date) => dayjs(date).format('YYYY-MM-DD');
  const [endDate, setEndDate] = useState(
    swimlaneData.endTime ? getDateString(swimlaneData.endTime) : ''
  );
  const [showEndDate, setShowEndDate] = useState(!!endDate);

  const handleCheckboxClick = () => {
    if (showEndDate) {
      setShowEndDate(false);
      setEndDate('');
    } else {
      setShowEndDate(true);
      setEndDate(
        swimlaneData.endTime ? getDateString(swimlaneData.endTime) : ''
      );
    }
  };

  const handleClick = () => {
    if (endDate) {
      onReady(getUnixTime(endDate));
    } else {
      onReady();
    }
    onHide();
  };

  return (
    <KiteModal
      className="swimlane-ready-modal"
      canShow={isOpen}
      title="Make Swimlane Ready to Deploy"
      disableBackgroundClose
      ctaAction={handleClick}
      ctaCopy="Make Ready"
      secondaryCtaAction={onHide}
      secondaryCtaCopy="Cancel"
    >
      <p>This will allow the swimlane to be deployed to production.</p>
      <KiteCheckbox
        name="toggle-end-date-ready"
        id="toggle-end-date-ready"
        label="End Date"
        checked={showEndDate}
        onChange={handleCheckboxClick}
        className="swimlane-ready-modal__checkbox"
      />
      <p className="swimlane-ready-modal__subtext">
        Set a date for this swimlane to be removed from production
      </p>
      {showEndDate && (
        <DatePicker
          onDateChange={(date) => setEndDate(date)}
          value={endDate}
          label="End Date"
          minDate={getDateString(new Date())}
        />
      )}
    </KiteModal>
  );
};

export default SwimlaneReadyModal;
